(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/configs/assets/javascripts/fallback.js') >= 0) return;  svs.modules.push('/components/sportinfo/configs/assets/javascripts/fallback.js');
"use strict";


const newEnetpulseWidgets = svs.core.detect.feature('ft-enetpulse-new');
const _svs$components$sport = svs.components.sportinfo.common,
  MatchState = _svs$components$sport.matchState.SportinfoMatchState,
  _svs$components$sport2 = _svs$components$sport.constants,
  SportinfoPathNames = _svs$components$sport2.SportinfoPathNames,
  ContentProvider = _svs$components$sport2.ContentProvider,
  SvsViewType = _svs$components$sport2.SvsViewType,
  SportradarWidgets = _svs$components$sport2.SportinfoSportradarWidgets;
const ConfigBuilder = svs.components.sportinfo.configBuilder.ConfigBuilder;
const _ConfigBuilder$addTab = new ConfigBuilder().addTab(SportinfoPathNames.MatchInfo, tab => {
    tab.setAll([{
      type: SvsViewType.MatchInfo,
      provider: ContentProvider.Svs
    }]);
  }).addTab(SportinfoPathNames.News, tab => {
    tab.setAll([{
      type: SvsViewType.News,
      provider: ContentProvider.Svs
    }]);
  }).addTab(SportinfoPathNames.Mutuals, tab => {
    tab.set(MatchState.NotStarted, [{
      type: SportradarWidgets.MatchPreview,
      provider: ContentProvider.SportRadar,
      viewProps: {
        disableMoreStats: true,
        disableExpandButton: true
      }
    }]);
  }).build(),
  content = _ConfigBuilder$addTab.content,
  menuItems = _ConfigBuilder$addTab.menuItems;
const _ConfigBuilder$addTab2 = new ConfigBuilder().addTab(SportinfoPathNames.MatchInfo, tab => {
    tab.setAll([{
      type: SvsViewType.MatchInfo,
      provider: ContentProvider.Svs
    }]);
  }).addTab(SportinfoPathNames.News, tab => {
    tab.setAll([{
      type: SvsViewType.News,
      provider: ContentProvider.Svs
    }]);
  }).build(),
  enetpulseMenuItems = _ConfigBuilder$addTab2.menuItems,
  enetpulseContent = _ConfigBuilder$addTab2.content;
setGlobal('svs.components.sportinfo.configs.sportConfigs', {
  fallbackConfig: newEnetpulseWidgets ? {
    menuItems: enetpulseMenuItems,
    content: enetpulseContent,
    config: 'fallback' 
  } : {
    menuItems,
    content,
    config: 'fallback' 
  }
});

 })(window);